import idb from "@/plugins/indexdb.js";
import { createPatient } from "../../repositories/patientsRepository";
import PatientsRepository from "../../repositories/patientsRepository";

function initialPatientState() {
  return {
    uuid: "",
    lastname: "",
    firstname: "",
    email: "",
    patient_id: "",
    nir: "",
    nir_key: "",
    dob: "",
    address: "",
    zipcode: "",
    city: "",
    phone: "",
    cellular: ""
  };
}

export default {
  namespaced: true,
  state: {
    patients: [],
    patient: initialPatientState()
  },
  mutations: {
    // Set patients
    setPatients(state, patients) {
      state.patients = patients;
    }
  },
  actions: {
    /**
     * Get patients
     */
    async getPatients() {
      const { data } = await PatientsRepository.get();
      return data;
    },

    /**
     * Create a patient on server
     *
     * @param payload Patient payload
     */
    async createPatient(context, payload) {
      const result = await createPatient(payload).catch(e => {
        return Promise.reject(e);
      });

      return result;
    },

    // Get a patient from api
    async getPatient(context, patientUuid) {
      const { data } = await PatientsRepository.getPatient(patientUuid);
      return data;
    },

    // Get all local patients from IndexedDB
    async getLocalPatients() {
      try {
        const patients = await idb.db.patients.toArray();
        return patients;
      } catch (error) {
        console.log(error);
      }
    },

    // Get local patient from IndexedDB
    getLocalPatient(context, patientUuid) {
      return new Promise((resolve, reject) => {
        idb.db.patients
          .get(patientUuid)
          .then(res => {
            if (!res) {
              reject("Patient not found. UUID: " + patientUuid);
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // Store a patient in local DB
    createLocalPatient(context, payload) {
      return new Promise((resolve, reject) => {
        idb.db.patients
          .add(payload)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // Clean store
    async clean({ commit }) {
      commit("setPatients", []);
      return;
    }
  },
  getters: {
    // Get a ptient by uuid
    getByUuid: state => uuid => {
      return state.patients.find(patient => patient.uuid == uuid);
    }
  }
};
